import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Size } from '../../types';
import { colors, sizes, eventDisplayMap } from '../../styles';
import { Icon } from '../icons/index';

export interface Props {
  className?: string;
  eventType: string;
  coordinates: { latitude: number; longitude: number };
  mapboxKey: string;
  mapboxStaticRoot: string;
  height?: number;
  width?: number;
  zoomLevel?: number;
  onImageLoadComplete?: () => void;
}

const baseWidth = 480;
const baseHeight = 152;

class StaticMap extends React.Component<Props, any> {
  backgroundMapUrl = (width: number, height: number) => {
    const defaultZoomLevel = 11;
    const { mapboxStaticRoot, mapboxKey, coordinates, zoomLevel } = this.props;

    const coords = `${coordinates.longitude},${coordinates.latitude}`;

    /* https://www.mapbox.com/help/how-static-maps-work/#mapbox-static-api */
    return `${mapboxStaticRoot}/${coords},${zoomLevel ||
      defaultZoomLevel}/${width}x${height}?access_token=${mapboxKey}`;
  };

  handleImageLoaded = () => {
    const { onImageLoadComplete } = this.props;
    onImageLoadComplete && onImageLoadComplete();
  };

  render() {
    const { className, eventType, coordinates, height, width } = this.props;

    const validCoordinates = !!(
      coordinates &&
      coordinates.longitude &&
      coordinates.latitude
    );

    if (!validCoordinates) {
      return (
        <div className={`${className} no-video`}>
          <Icon icon="noVideo" baseColor={colors.grey900} />
        </div>
      );
    }

    const fillColor = colors[eventDisplayMap[eventType].kind];
    const url = this.backgroundMapUrl(width || baseWidth, height || baseHeight);
    return (
      <div className={className}>
        <div className="map-container">
          <img src={url} onLoad={this.handleImageLoaded} />
        </div>
        <svg width="40" height="40">
          <circle
            cx="20"
            cy="20"
            r="18"
            fill={fillColor}
            fillOpacity={0.2}
            strokeWidth={2}
            stroke={fillColor}
            strokeOpacity={0.5}
          />
          <circle
            cx="20"
            cy="20"
            r="7"
            fill={fillColor}
            strokeWidth={3}
            stroke={colors.white}
          />
        </svg>
      </div>
    );
  }
}

export default styled(StaticMap)`
  height: ${props => props.height || baseHeight}px;
  width: ${props => props.width || baseWidth}px;
  border-radius: 6px;
  background-color: ${colors.grey200};
  background-size: cover;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  .map-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }
  svg {
    z-index: 2;
  }
  .pin-centerer {
    > * {
      position: absolute;
    }
  }
`;
